__webpack_require__.p = "https://assets.canny.io/f77afbc67fc420a7640d84c05dba14a29a958641/";